<template>
  <div
    class="pcart-bag"
    tabindex="0"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <zm-badge
      type="counter"
      :count="count"
      :hidden="count === 0"
      position="bottom"
      color="blue"
      size="sm"
      class="pcart-bag__badge"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="pcart-bag__icon"
        aria-label="Shopping Cart"
      >
        <g clip-path="url(#clip0_7147_102747)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.2328 3.93756H16.875C17.5302 3.93756 18.0468 4.49547 17.9966 5.14881L17.6335 9.87045C17.535 11.1527 16.5817 12.1777 15.349 12.4097C15.3371 12.4123 15.3255 12.4155 15.3139 12.4187C15.2875 12.426 15.2612 12.4332 15.2326 12.4332C15.2288 12.4332 15.2254 12.4322 15.2219 12.4311C15.2187 12.4302 15.2155 12.4292 15.212 12.4291C15.1835 12.433 15.1553 12.4379 15.1272 12.4428C15.0736 12.4521 15.0201 12.4614 14.9645 12.464L13.2429 12.5469L13.2374 12.547L11.2456 12.643L11.2352 12.6433L5.36779 12.9254L5.02515 13.2467C4.72083 13.5335 4.54504 13.9389 4.54504 14.358V15.1874L14.353 15.1875C14.363 15.1875 14.3721 15.1903 14.3812 15.193C14.3897 15.1956 14.3982 15.1981 14.4075 15.1985C14.4642 15.2043 14.5212 15.2103 14.5717 15.2317C15.24 15.3405 15.7592 15.8947 15.7592 16.5938C15.7592 17.3704 15.1297 18 14.353 18C13.5764 18 12.9467 17.3704 12.9467 16.5938C12.9467 16.5259 12.9638 16.4636 12.981 16.4011C12.989 16.3718 12.9971 16.3424 13.0034 16.3124H5.33222C5.33855 16.3425 5.34666 16.372 5.35476 16.4014C5.37194 16.4637 5.38908 16.5259 5.38908 16.5938C5.38908 17.3704 4.75956 18 3.98296 18C3.20623 18 2.57671 17.3704 2.57671 16.5938C2.57671 16.018 2.92456 15.526 3.42004 15.3084V14.358C3.42004 13.6296 3.72437 12.9254 4.25501 12.4266L4.53544 12.1642C4.46224 11.651 4.37916 11.0751 4.2899 10.4621L4.27671 10.3717L4.25742 10.2395C4.22506 10.0175 4.19223 9.79244 4.15902 9.56576L4.15847 9.56192C3.76145 6.85085 3.32612 3.93756 3.32612 3.93756H3.33298C3.20774 3.08743 3.0895 2.28583 2.98828 1.60015C2.94763 1.32441 2.71362 1.125 2.43237 1.125H0.5625C0.251584 1.125 0 0.873416 0 0.5625C0 0.251584 0.251595 0 0.5625 0H2.43237C3.27612 0 3.97815 0.603697 4.1012 1.4359C4.209 2.1656 4.3359 3.02617 4.47006 3.93756H12.9703H12.9729H15.2328ZM14.6699 11.0703L13.758 11.1141L9.80907 11.304L7.83459 11.3989L5.86011 11.4939L4.95703 5.34375H5.76124H15.7949H16.5711L16.4846 6.46868L16.2898 8.99992C16.2898 8.99992 16.2099 9.91707 16.1347 10.1249C16.0594 10.3328 15.952 10.5229 15.7949 10.672C15.5589 10.908 14.9466 11.0359 14.6699 11.0703Z"
            fill="#000000"
          />
        </g>
        <defs>
          <clipPath id="clip0_7147_102747">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </zm-badge>
  </div>
</template>

<script>
/**
 * Shopping bag event constants
 */
export const SHOPPING_BAG_EVENTS = {
  CLICK: 'click',
  MOUSE_ENTER: 'mouseenter',
  MOUSE_LEAVE: 'mouseleave',
};
</script>

<script setup>
import { getCurrentInstance } from 'vue';

// Props
defineProps({
  count: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0,
  },
});

// Emits
const emit = defineEmits(Object.values(SHOPPING_BAG_EVENTS));

// Get current instance for $tracking
const instance = getCurrentInstance();
const $tracking = instance?.appContext.config.globalProperties.$tracking;

// Methods
const handleClick = (event) => {
  $tracking?.persistentCart('cart icon - click');
  // always emit click event, let parent handle the logic
  emit(SHOPPING_BAG_EVENTS.CLICK, event);
};

const handleMouseEnter = (event) => {
  // emit mouseenter event
  emit(SHOPPING_BAG_EVENTS.MOUSE_ENTER, event);
};

const handleMouseLeave = (event) => {
  // emit mouseleave event
  emit(SHOPPING_BAG_EVENTS.MOUSE_LEAVE, event);
};
</script>

<style lang="scss" scoped>
.pcart-bag {
  &__badge {
    display: inline-block;
    cursor: pointer;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    :deep(.zbo-badge__counter) {
      position: absolute;
      top: 25px;
      right: 17px;
      transform: translateY(-50%) translateX(100%);
      background-color: var(--zoom-color-text-primary, #0d6bde);
      font-size: 10px;
    }
  }

  &__icon {
    width: 18px;
    height: 18px;
    display: block;
  }
}
</style>
